import { PrestationHeader } from "../../../shared/components/PrestationHeader/PrestationHeader";
import routes from "../../../engine/routes";
import { Skeleton } from "antd";
import CustomForm from "../../../shared/components/CustomForm";
import { prestationInputs } from "../PrestationDetail/PrestationDetailForm";
import React, { useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { initPrestationSlice } from "../Slices/Prestation.slice";
import { PrestationEstimationCost } from "../PrestationResume/PrestationEstimationCost";
import {
  daysJsFormat,
  statusPrestationsValues,
  subRoles,
  subStatus,
} from "../../../utils/constants";
import { RenderBillInfo } from "../../../shared/components/Billing/RenderBillInfo";
import { onlyRoleMapping } from "../../../engine/AuthRoute";
import dayjs from "../../../utils/dayjs";

export const PrestationBilling = () => {
  const { id } = useParams();
  const { prestation, loading } = useSelector(state => state.prestation);
  const { init, clear, ready } = initPrestationSlice({ id });

  let isCanceledClient =
    [statusPrestationsValues.cancelClient].includes(prestation.status) ||
    [subStatus.institution].includes(prestation.subStatus);

  let isCancelInterprete =
    [statusPrestationsValues.cancelInterprete].includes(prestation.status) ||
    [subStatus.interprete].includes(prestation.subStatus);

  let isFinish = [
    statusPrestationsValues.finish,
    statusPrestationsValues.finish_notsigned,
    statusPrestationsValues.finish_permanance,
  ].includes(prestation.status);

  const isEstimation = [
    statusPrestationsValues.waiting,
    statusPrestationsValues.planned,
  ].includes(prestation.status);

  let checkTimeValid = true;
  let now = dayjs();
  let availableAt = dayjs(prestation?.bill?.createdAt).add(72, "hours");

  if (onlyRoleMapping(subRoles.institutionFinance)) {
    checkTimeValid = now.isAfter(availableAt, "minutes");
  }


  return (
    <div key={isEstimation ? prestation._id : prestation?.bill?._id}>
      <PrestationHeader
        title={
          isEstimation
            ? "Estimation des coûts de la prestation "
            : routes.prestations(id).detailBilling.title
        }
      />
      <br />

      {isEstimation && (
        <PrestationEstimationCost
          key={prestation._id}
          estimation={isEstimation}
        />
      )}

      {!isEstimation ? (
        prestation.bill === null || prestation.bill === undefined ? (
          <>
            {prestation.status === statusPrestationsValues.finish &&
            prestation?.institution?.groupedBilling === true ? (
              <>La facturation groupée n'est pas encore créée.</>
            ) : (
              <h3>La facture n'est pas créee.</h3>
            )}
          </>
        ) : (
          <>
            {checkTimeValid ? (
              <>
                {" "}
                <RenderBillInfo
                  title={"Informations de facturation"}
                  loading={loading}
                  bill={prestation?.bill}
                />
                <PrestationEstimationCost
                  key={prestation._id}
                  estimation={isEstimation}
                />
              </>
            ) : (
              <p>
                Facture disponible le {availableAt.format(daysJsFormat.full)}
              </p>
            )}
          </>
        )
      ) : null}
      {}
    </div>
  );
};
